// extracted by mini-css-extract-plugin
export default {"root":"FamilyCard__root--1vxHN","crossedOldPrice":"FamilyCard__crossedOldPrice--3eNez"};